/** 2026-10-11: quota/security xətasında QR sessiyası və profil itirdi.
 * Uğursuz yazı/silmə yaddaşda üstün tutulur; köhnə disk dəyəri geri qayıtmır. */
const memory: { [key: string]: string | null } = Object.create(null)
const overrides: { [key: string]: boolean } = Object.create(null)

export function readStored(key: string): string | null {
  if (overrides[key]) return memory[key] || null
  try {
    const value = window.localStorage.getItem(key)
    memory[key] = value
    return value
  } catch { return memory[key] || null }
}

export function writeStored(key: string, value: string | null): void {
  memory[key] = value
  try {
    if (value === null) window.localStorage.removeItem(key)
    else window.localStorage.setItem(key, value)
    delete overrides[key]
  } catch { overrides[key] = true }
}
